export default function Title({ heading, description }) {
  return (
    <div className="text-center mb-16">
      <h2 className="text-3xl font-bold mb-4">
        {heading}
      </h2>
      <p className="text-xl max-w-2xl mx-auto">
        {description}
      </p>
    </div>
  );
}
